import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const BackupCodeContainer = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

export const BackupCodeTitle = styled(Typography)(() => ({
  fontSize: "26px",
  fontStyle: "normal",
  fontWeight: 600,
  textAlign: "center",
  marginBottom: "16px",
  color: "#1B252F",
}));

export const BackupCodeSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textAlign: "center",
  fontFamily: "Nunito",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "32px",
  marginBottom: "44px",
}));

export const BackupCodeForm = styled("form")(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "24px",
}));

export const BackupCodeActions = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  gap: "24px",
  alignItems: "center",
  marginTop: "16px",
}));




